import Helpers from '../../typescript/modules/helpers.js';
import SlideToggle from '../../typescript/modules/slide-toggle.js';
import Tracking from '../../typescript/modules/tracking.js';

if (Helpers.activeSite() === 'Drench') {
	new SlideToggle();

	document.addEventListener('click', (e) => {
		const clicked = e.target as Element | null;
		const trigger = clicked?.closest('#finance-accordion-title') as HTMLElement | null;
		if (!trigger) return;
		const isPPC = document.getElementById('product')?.hasAttribute('data-ppc-page');
		setTimeout(() => {
			if (trigger.getAttribute('aria-expanded') === 'true') {
				Tracking.customEvent('finance_accordion_open', { page_type: isPPC ? 'ppc' : 'product' });
			}
		}, 0);
	}, { capture: true });
}
